export const environment = {
  production: true,
  version: 'cf7b3b232a',
  site_version: 'SITE_VERSION'
};
